import { Chip } from '@material-ui/core'
import clsx from 'clsx'
import { find } from 'lodash'

import { Card, Permitted } from 'components'
import {
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
} from 'components/Table'
import { AddCompanyDialog } from './components'

import useStyles from './styles'
import formatters from 'helpers/formatters'
import constants from 'constants/index'

const CompaniesTable = ({
  integrationPartner,
  refresh,
  upgradablePlans = [],
}) => {
  const classes = useStyles()

  const selectPlanName = (planId) =>
    find(upgradablePlans, { plan: { id: planId } })?.name ?? 'Plano de entrada'
  const integrationPartnerCompanies =
    integrationPartner?.integrationPartnerCompanies || []

  return (
    <Card
      title="Empresas vinculadas"
      actionButton={
        <Permitted
          tag={constants.permissions.INTEGRATION_PARTNERS.LINK_COMPANY}
        >
          <AddCompanyDialog
            integrationPartner={integrationPartner}
            refresh={refresh}
          />
        </Permitted>
      }
      dropdown
      defaultExpanded
    >
      <Table emptyMessage="Nenhuma empresa encontrada">
        <TableHead>
          <TableRow>
            <TableCell width="25%">Token</TableCell>
            <TableCell width="25">Empresa</TableCell>
            <TableCell width="15%">Plano</TableCell>
            <TableCell width="10%">Documento</TableCell>
            <TableCell width="10%">Status</TableCell>
            <TableCell width="15%">Data de criação</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {integrationPartnerCompanies?.map((integrationPartnerCompany) => (
            <TableRow key={integrationPartnerCompany?.company?.token} hover>
              <TableCell disableTooltip noOverFlow>
                {integrationPartnerCompany?.company?.token}
              </TableCell>
              <TableCell>{integrationPartnerCompany?.company?.name}</TableCell>
              <TableCell>
                {selectPlanName(integrationPartnerCompany?.planId)}
              </TableCell>
              <TableCell>
                {formatters.cnpj(integrationPartnerCompany?.company?.cnpj)}
              </TableCell>
              <TableCell disableTooltip>
                <Chip
                  className={clsx(classes.root, {
                    [classes.active]:
                      integrationPartnerCompany?.status === 'active',
                    [classes.inactive]:
                      integrationPartnerCompany?.status !== 'active',
                  })}
                  align="center"
                  size="small"
                  label={
                    integrationPartnerCompany?.status === 'active'
                      ? 'Ativo'
                      : 'Inativo'
                  }
                />
              </TableCell>
              <TableCell>
                {formatters.date(integrationPartnerCompany?.company?.createdAt)}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </Card>
  )
}

export default CompaniesTable
